import React, { Component } from "react";
import LMTestService from '../utils/LMTestService';


class TestPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: 'jakcharlton@gmail.com',
      password: ''
    }
  }

  fetchToken = (event) => {
    event.preventDefault()
    const { email, password } = this.state
    LMTestService.getToken(email,password).then(data => {
      console.log(data)
    })
  }

  onChange = e => this.setState({ [e.target.name]: e.target.value })

  render() {
    const { email, password } = this.state

    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <h3>TEST</h3>
            <form onSubmit={this.fetchToken}>
              <input
                type="text"
                name="email"
                value={email}
                onChange={this.onChange}
              />
              <input
                type="text"
                name="password"
                value={password}
                onChange={this.onChange}
              />
              <button type='submit'>FETCH</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default TestPage